import { getLocalStorage, setLocalStorage } from '@/utils/storage';

export const UPDATE_LOCALIZATION = 'localization/UPDATE_LOCALIZATION';

export enum LocalizationActions {
  UPDATE_LOCALIZATION = 'localization/UPDATE_LOCALIZATION',
}

export type LocalizationType = {
  countryName: string;
  countryCode: string;
  locale: string;
};

export const LOCATIONS: LocalizationType[] = [
  { countryName: 'United States', countryCode: 'US', locale: 'en' },
  { countryName: 'Brazil', countryCode: 'BR', locale: 'pt-br' },
];

export const initialState: LocalizationType = {
  countryName: getLocalStorage('localization')?.countryName || 'United States',
  countryCode: getLocalStorage('localization')?.countryCode || 'US',
  locale: getLocalStorage('localization')?.locale || 'en',
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function reducer(state = initialState, action: any) {
  switch (action.type) {
    case UPDATE_LOCALIZATION: {
      setLocalStorage('localization', action.localization);
      return {
        ...state,
        ...action.localization,
      };
    }
    default:
      return state;
  }
}
